module.exports = __webpack_public_path__ + "static/media/weddingVendor.ffdb6634.png";